export enum SmsStatus {
  PENDING = 'pending',
  ENQUEUED = 'enqueued',
  PROCESSING = 'processing',
  SENT = 'sent',
  CANCELED = 'canceled',
}
